import ContentLoader from 'react-content-loader';
import React from 'react';
import theme from 'src/shared/theme';
import { Columns } from '../columns';

export const CatalogListLoader = (
    <Columns $xs={2} $md={5} $lg={5} $gap={30}>
        {new Array(10).fill(0).map((_, idx) => (
            <ContentLoader
                key={idx}
                speed={2}
                width='100%'
                height='248px'
                backgroundColor={theme.skeleton.backgroundColor}
                foregroundColor={theme.skeleton.foregroundColor}
            >
                <rect x={'0'} y={'0px'} rx='0' ry='0' width='100%' height='200px' />
                <rect x={'0'} y={'210px'} rx='3' ry='3' width='70%' height='17px' />
                <rect x={'0'} y={'230px'} rx='3' ry='3' width='40%' height='17px' />
            </ContentLoader>
        ))}
    </Columns>
);
